<app-header></app-header>
<div class="menu">
    @if (sideComponent !== null) {
        <div class="side" [ngStyle]="sideBottomPadding ? {bottomPadding: '10rem'} : {}">
            <ng-template *ngComponentOutlet="sideComponent"></ng-template>
        </div>
    }
    <div class="page-content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>
<app-footer></app-footer>
